import React from "react";
import { observer } from "mobx-react";
import { WeaTimePicker } from "ecCom";

@observer
export default class TimePickerItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaTimePicker
        ecId={`${this.props.ecId}_WeaTimePicker@aimofn`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
        formatPattern={c.formatPattern || 3}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/TimePickerItem.js